import { useProductEditor } from '../product-editor-context'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Plus, Trash2, Settings2 } from 'lucide-react'

export function SpecsSection() {
  const {
    specs,
    addSpec,
    removeSpec,
    updateSpec,
  } = useProductEditor()

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Settings2 className="size-5 text-zinc-500" />
            <div>
              <CardTitle className="text-base">Specifications</CardTitle>
              <CardDescription>
                Technical specs as key-value pairs ({specs.filter(s => s.key && s.value).length} added)
              </CardDescription>
            </div>
          </div>
          <Button type="button" variant="outline" size="sm" onClick={addSpec}>
            <Plus className="mr-1 size-3" /> Add Spec
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {specs.map((spec, i) => (
            <div key={i} className="flex flex-col gap-2 sm:flex-row">
              <Input
                value={spec.key}
                onChange={(e) => updateSpec(i, 'key', e.target.value)}
                placeholder="Spec name"
                className="w-full sm:w-1/3"
              />
              <Input
                value={spec.value}
                onChange={(e) => updateSpec(i, 'value', e.target.value)}
                placeholder="Value"
                className="w-full sm:flex-1"
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => removeSpec(i)}
                className="h-10 w-10 text-red-500 hover:text-red-600 hover:bg-red-50"
              >
                <Trash2 className="size-4" />
              </Button>
            </div>
          ))}
          {specs.length === 0 && (
            <p className="text-sm text-zinc-400 text-center py-4">
              No specs added yet. Click "Add Spec" to start.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
